<template>
  <v-menu v-model="open"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
          @input="onMenuToggle">
    <v-list>
      <div v-for="(action, index) in actions" :key="index">
        <v-divider v-if="action.dividerBefore"/>
        <v-list-item
            style="cursor: pointer;"
            :disabled="action.disabled"
            @click="action.click">
          <v-list-item-icon
              style="margin-top: 0.75rem; margin-bottom: 0; margin-right: 1rem;">
            <v-icon>{{ action.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content style="padding-top: 0; padding-bottom: 0">
            <v-list-item-title>{{ action.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="action.dividerAfter"/>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
/**
 * {
 *   icon:  mdi icon name like 'mdi-delete', optional
 *   label: label text , required
 *   click: function to call, required
 *   disabled: disables action, optional defaults to false
 *   dividerBefore: true|false. Add divider line before this action
 *   dividerAfter: true|false. Add divider line after this action
 * }
 */
import Vue from 'vue';

export default Vue.extend({
  name: 'EntityActionContextMenu',
  data: () => ({
    open: false,
    actions: [],
    x: 0,
    y: 0,
  }),
  methods: {
    show(event, actions) {
      console.log('should show menu');
      event.preventDefault();
      this.actions = actions;
      this.open = false;
      this.x = event.clientX;
      this.y = event.clientY;
      this.$nextTick(() => {
        this.open = true;
      });
    },
    onMenuToggle(open){
      if (!open){
        this.actions = [];
      }
    },
  },
});
</script>

<style scoped>

</style>
